import React from 'react';

import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';

import { forceLogout } from '../../api/axiosInstance';
import { useTranslation } from '../../hooks';
import { Button, Tooltip } from '../MuiGenerals';

const sx = {
  logoutBtn: {
    overFlowY: 'hidden',
    minWidth: '90px',
    height: '20px',
    borderRadius: '30px 29.5px 29.5px 30px',
    padding: '4px 8px 4px 8px',
    svg: {
      width: '12px',
      height: '12px',
    },
  },
};

interface IProps {
  title?: string;
  isTopBar?: boolean;
  isHide?: boolean;
}

const LogoutButton = (props: IProps) => {
  const { title, isTopBar, isHide } = props;

  const { tc } = useTranslation();

  const logoutFn = () => {
    forceLogout('', { from: 'menu-button' });
  };

  const buttonText = title || tc('logout');

  if (isHide) {
    return <></>;
  }

  if (isTopBar) {
    return (
      <Tooltip title={buttonText} onClick={logoutFn}>
        <PowerSettingsNewIcon sx={{ width: '20px', height: '20px', cursor: 'pointer' }} />
      </Tooltip>
    );
  }

  return (
    <Button
      variant="outlined"
      size="small"
      startIcon={<PowerSettingsNewIcon />}
      onClick={logoutFn}
      sx={sx.logoutBtn}
    >
      {buttonText}
    </Button>
  );
};

export default LogoutButton;
